import { API } from '@Providers';

interface RemoveCustomAdditionalFeePayload {
  animal_id: string;
  fee_index: number;
}

export default async function (payload: RemoveCustomAdditionalFeePayload) {
  const endpoint = '/api/shelter/cart/remove-custom-additional-fee';

  return API({ endpoint, method: 'patch', payload });
}
